import { render, staticRenderFns } from "./NicheShow.vue?vue&type=template&id=2432dac8&"
import script from "./NicheShow.vue?vue&type=script&lang=js&"
export * from "./NicheShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports